import { MedicalCategoriesQuery, MedicalCategoryIconType, MedicalCategorySortType } from '@/types/bff/gql-schema';
import { QueryClient } from '@tanstack/react-query';

import { MedicalCategoryVo } from '@/types/hospital';
import { useMedicalCategoriesQuery } from './hospitalMain.gql.impl';

const parseMedicalCategoriesVo = (data: MedicalCategoriesQuery): Array<MedicalCategoryVo> => {
  const getCategoryIconType = (iconType: MedicalCategoryIconType): 'ANIMATION' | 'PLAIN_IMAGE' => {
    switch (iconType) {
      case MedicalCategoryIconType.Animation:
        return 'ANIMATION';
      case MedicalCategoryIconType.PlainImage:
      default:
        return 'PLAIN_IMAGE';
    }
  };

  return data.medicalCategories.map((data) => {
    return {
      ...data,
      iconType: getCategoryIconType(data.iconType),
    };
  });
};

interface Params {
  sortType: MedicalCategorySortType;
  enabled?: boolean;
}
const useMedicalCategories = ({ sortType, enabled = true }: Params) => {
  const { data } = useMedicalCategoriesQuery(
    {
      request: {
        sortType,
      },
    },
    { select: parseMedicalCategoriesVo, enabled: enabled }
  );
  return { data };
};

export default useMedicalCategories;

useMedicalCategories.prefetchQuery = async (queryClient: QueryClient, sortType: MedicalCategorySortType) => {
  await queryClient.prefetchQuery(
    useMedicalCategoriesQuery.getKey({ request: { sortType } }),
    useMedicalCategoriesQuery.fetcher({ request: { sortType } })
  );
};
useMedicalCategories.fetchQuery = async (queryClient: QueryClient, sortType: MedicalCategorySortType) => {
  const response = await queryClient.fetchQuery(
    useMedicalCategoriesQuery.getKey({ request: { sortType } }),
    useMedicalCategoriesQuery.fetcher({ request: { sortType } })
  );

  return parseMedicalCategoriesVo(response);
};
